export default "__VITE_ASSET__1f3f13d1__"